import React, { useLayoutEffect, useRef, useState } from 'react';
import { Icon } from '@doxyme/ui';
import { useProgress, PROGRESS_DEFAULT_RESET, } from '../../helpers/use-progress';
export const ProgressButton = ({ isLoading, hasError, progress, slowFactor = 1, reset = PROGRESS_DEFAULT_RESET, children, successLabel: _successLabel, errorLabel: _errorLabel, ...rest }) => {
    const { 'aria-label': ariaLabelProp, 'aria-labelledby': ariaLabelledByProp, ...buttonRest } = rest;
    const hasAriaLabel = typeof ariaLabelProp === 'string' && ariaLabelProp.trim() !== '';
    const hasAriaLabelledBy = typeof ariaLabelledByProp === 'string' && ariaLabelledByProp.trim() !== '';
    const defaultLabelMeasureRef = useRef(null);
    const [labelFromDom, setLabelFromDom] = useState('');
    useLayoutEffect(() => {
        if (hasAriaLabel || hasAriaLabelledBy) {
            return;
        }
        const el = defaultLabelMeasureRef.current;
        if (!el) {
            return;
        }
        setLabelFromDom(el.textContent?.trim() ?? '');
    }, [children, hasAriaLabel, hasAriaLabelledBy]);
    const containerRef = useRef(null);
    const barRef = useRef(null);
    useProgress(isLoading, hasError, reset, slowFactor, progress, containerRef, barRef);
    const ariaLabelResolved = hasAriaLabel
        ? ariaLabelProp.trim()
        : hasAriaLabelledBy
            ? undefined
            : labelFromDom || undefined;
    return (<button {...buttonRest} ref={containerRef} aria-busy={isLoading ?? undefined} aria-label={ariaLabelResolved} aria-labelledby={hasAriaLabel
            ? undefined
            : hasAriaLabelledBy
                ? ariaLabelledByProp
                : undefined}>
      <span className="progress-button-surface" aria-hidden="true">
        <span className="progress">
          <span className="progress-inner" ref={barRef}/>
        </span>

        <span className="progress-content">
          <span className="progress-default" ref={defaultLabelMeasureRef}>
            {children}
          </span>

          <span className="progress-success">
            <Icon name="ok" className="icon ok" size="x-small"/>
          </span>

          <span className="progress-error">
            <Icon name="close-old" className="icon close" size="x-small"/>
          </span>
        </span>
      </span>
    </button>);
};
